import { motion } from "framer-motion";



export default function TestimonialsSection() {
  
  return (
    <motion.section
    id="testimonios"
      className="bg-eryndra-testimonial bg-cover bg-center h-[38rem] h-movil-testimonial px-8 sm:px-8 py-32 sm:py-[6.5rem] text-center  relative "
      initial={{ opacity: 0, y: 30 }}
      animate={{ opacity: 1, y: 0 }}     
      transition={{ delay: 1, duration: 1 }}
    >
      {/* <div className="!pl-0 !ml-0 absolute top--1 left-0 w-full h-24 bg-gradient-to-b to-transparent from-eryndra-forest opacity-100 pointer-events-none z-10" /> */}
      {/* <h2 className="text-3xl font-bold mb-4 text-shadow-sm">¿Preparado para vivir tu cuento?</h2>
      <p className="mb-6 text-shadow-sm">Contacta con nosotras y déjanos hacer realidad tu historia.</p>
      <button className="btn-eryndra-forest">Escribe tu historia</button> */}
      <motion.div 
      whileHover={{ scale: 1.05 }}
      transition={{ duration: 0.3 }}
      className="max-w-2xl md:max-w-4xl mx-auto my-auto h-full bg-eryndra-ivory/5 backdrop-blur-lg rounded-3xl 
      md:rounded-[3rem] px-3 sm:px-0 py-8 sm:py-16 border-2 border-eryndra-gold shadow-lg cursor-pointer">
    <h2 className="text-2xl md:text-[2.7rem] font-title  tracking-wide  text-eryndra-cream mb-6 text-shadow-sm">
      eXPeRIeNCIAS INOLVIDABLeS
    </h2>
    <p className="font-bellefair px-1 sm:px-20 text-sm md:text-2xl leading-relaxed text-eryndra-cream text-shadow-sm">
      En Eryndra Eventos queremos conseguir que todos los momentos que compartas con nosotras
      sean únicos. Vengas a uno de nuestros bailes o nos pidas un evento personalizado, queremos
      que recuerdes siempre ese día y quieras repetir con nosotras. En Eryndra nos especializamos
      en eventos literarios donde podrás sumergirte en un mundo de fantasía.
    </p>

    

    {/* Adorno opcional 
    <div className="mt-4 flex justify-center gap-6 ">
      <img src="/img/detallecard.png" alt="Decoración izquierda" className="h-8 " />
    </div>*/}
    <div className="mt-9">
    <a href="/nosotras" className=" btn-eryndra">Conócenos</a>
    </div>
    
  </motion.div>

  
    </motion.section>
  );
}
